import React from 'react';

const SocialLinks = () => {
  const socialLinks = [
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/sanyu_ns/'
    },
    {
      name: 'Facebook', 
      url: 'https://www.facebook.com/sanyu.c.n'
    },
    {
      name: 'YouTube',
      url: 'https://www.youtube.com/@sanyu_ns'
    },
    {
      name: 'Spotify',
      url: 'https://open.spotify.com/artist/76le7pywkDxWlcafPNwaHU?si=x67UHMXyS2S7Lr7qfEADZA'
    }
  ];

  return (
    <div className="social-links">
      {socialLinks.map((link, index) => (
        <a 
          key={index}
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
          className="social-link"
        >
          {link.name}
        </a>
      ))}
    </div>
  );
};

export default SocialLinks; 